/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    try{
      const addItems = [];
      const submitButton = this.querySelector('[type="submit"]');
      const qtyInput = this.querySelector('[data-qty-input]');
      
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
      addItems.push(JSON.parse(serializeForm(this.form)));
      const body = JSON.stringify({
        items: addItems,
        sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
      });
      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(async (res) => {
        let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
        if(dataJSON.errors){
          console.error(dataJSON.errors)
        }
  
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        if(qtyInput) qtyInput.value = 1;
        let swatch_form = document.querySelectorAll('.swatch');
          swatch_form.forEach( ele => {
              ele.classList.contains('loading') ? ele.classList.remove('loading') : '';
          })
  
        if (!dataJSON.errors) {
          if(this.cartElement){
            let packageProtectionIndex = window.globalVariables.cart.items.findIndex((item) => {
              return item.properties['_shipping_protection'] == true;
            });
            if ((window.globalVariables.cart.attributes['_shipping_protection'] == undefined || window.globalVariables.cart.attributes['_shipping_protection'] == 'N/A') && packageProtectionIndex == -1) {
              document.dispatchEvent(autoAddShippingProtectionEvent);
              await new Promise(resolve => setTimeout(resolve, 1000));
            }
            this.cartElement.getCartData('open_drawer');
          }else if(document.querySelector('.cart-count')){
            document.querySelector('.cart-count')?.classList.remove('d-none');
          }else{
            window.location.href = window.routes.cart_fetch_url;
          }      
        }
      })
      .catch((e) => {
        console.error(e);
        Utility._rollBar(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
    }catch(err){
      console.error(err,'error')
      Utility._rollBar(err)
    }
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget?.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    if(!this.form) return;
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.addEventListener('click',(event)=>{
      let inputEle = event.target.closest('input');
      if(inputEle){
        if(inputEle !=null || inputEle.hasAttribute('checked')){
          this.onVariantChange(event);
        }
      }
    })
  }

  connectedCallback() {
    // Element Connected callback
    
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
      this.setCurrentVariant();
      if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new Event('variant:changed'));
      
      if (!this.currentVariant) {
        this.toggleAddButton('disable');
        this.updateOptionLabel(this.form); 
      } else {
        if(this.formType == 'grid'){
          const productGrid = this.closest('[data-product-grid]');
          this.renderProductInfo(this.currentVariant, productGrid);
          this._updateLinks(productGrid); 
        }else{
          const productPage = this.closest('[data-product-container]');
          this.renderProductInfo(this.currentVariant, productPage);
        }
        this.updateURLandID(this.currentVariant);
        this.toggleAddButton('enable');

        if (this.form.querySelectorAll('[data-onetime-price]').length) {
          this.form.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
            ele.innerHTML = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format)
          })
        }
        // if (this.form.querySelectorAll('[data-subscription_price]').length) {
        //   this.form.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
        //     ele.innerHTML = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format)
        //   })
        // }


        if(_event != 'load')  { 
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
            let subscription_price=Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format)
            if (ele.closest('[data-select-subscription_price]')) {
              let text=ele.innerText.split(window.globalVariables.money_format.replaceAll('{{amount}}',''));
              ele.innerText=`${text[0]} ${subscription_price}`
            }else{
              ele.innerHTML=subscription_price;
            }
          })
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
            
            let onetime_price=Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format)
              ele.innerHTML=onetime_price;
          })
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-subscription_percentage]').forEach((ele)=>{
            let subscription_percentage=this.currentVariant.recharge_discount_percentage
            ele.innerHTML=subscription_percentage;
          })

          if (this.form.querySelector('recharge-widget')) {
            rechargeWidget.prototype._toggleOptions(_event);
            rechargeWidget.prototype._changeSellingPlan(_event);
            let selectedItemType = this.form.querySelector('[data-purchase_type].selected')?.getAttribute('data-purchase_type') || 'onetime';
            if (selectedItemType == 'onetime') {
              let onetime_price = this.form.querySelector('[data-onetime-price]').innerHTML;
              this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = onetime_price
            }else{
              let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
              this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price
            }
          }

        }
        
        let swatchForm = this.closest('product-form[data-form-productswatch]');
        if(swatchForm){
          _event.target.closest('.swatch').classList.add('loading');
        }
        (swatchForm && swatchForm.querySelector('[data-btn_submit]')) ? swatchForm.querySelector('[data-btn_submit]').click() : '';
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = this.currentVariant[lableID];
    });

    let stickyAddtocart = form.querySelector('[data-stick-add-to-cart]');
    if (stickyAddtocart) {
      let variantTitleEle = stickyAddtocart.querySelector('[data-variant-title]');
      if (variantTitleEle) {
        variantTitleEle.innerHTML = this.currentVariant.title
      }
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;
    let template_name = window._template.suffix
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this?.dataset.url}?variant=${currentVariant.id}${template_name != "" ? `&view=${template_name}` : ''}`);

    const input = this.form.querySelector('input[name="id"]');
    if (input) {
      input.value = currentVariant.id;
    }
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelectorAll('[data-comparePrice]');
    let stickyPriceElement = container.querySelector('[data-sticky-price]');
    if (stickyPriceElement) {
      stickyPriceElement.innerHTML = price
    }
    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement.length) {
      comparePriceElement.forEach((compareEle)=>{
        compareEle.innerHTML = compare_price;
        if(currentVariant.compare_at_price <= 0 || compare_price == price){
          compareEle.classList.add('d-none');
        }else{
          compareEle.classList.remove('d-none');
        }
      })
      if(currentVariant.compare_at_price <= 0 || compare_price == price){
        priceElement.classList.remove('text-secondary-4');
        priceElement.classList.remove('fw-semibold');
        priceElement.classList.add('fw-medium');
      }else{
        priceElement.classList.add('text-secondary-4');
        priceElement.classList.remove('fw-medium');
        priceElement.classList.add('fw-semibold');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('disabled');
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('disabled');
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.classList.remove('disabled');
      if (this.addBtn.querySelector('.add-text')) {
        if(this.form.classList.contains('cart-upsell-form')){
          this.addBtn.querySelector('.add-text').innerHTML = `<span class="icon-plus"></span>${window.variantStrings.upsellAddText.trim()}`;
        }else{
          this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
        }
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || (this.variant_json ? JSON.parse(this.variant_json?.textContent) : false);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form?.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]')?.dataset?.handle;
        if(!colorHandle) return;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      })
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class rechargeWidget extends HTMLElement {
  constructor() {
    super();
    
    this.optionSelectors = this.querySelectorAll('[data-purchase_type]');
    this.optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    this.sellingPlans=this.querySelectorAll('[data-purchase_type="subscription"] select');
    this.sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

  }
  _toggleOptions(event){
    this.form=event.target.closest('form');
    if (this.form.closest('[data-product-container]') && this.form.querySelector('recharge-widget')) {
      this.type=this.form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
      document.querySelector('[data-purchase_type].selected')?.classList.remove('selected');
      document.querySelector(`[data-purchase_type="${this.type}"]`)?.classList.add('selected');
    }
    if (this.type == 'onetime') {
      let onetime_price = this.form.querySelector('[data-onetime-price]').innerHTML;
      this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = onetime_price
    }else{
      let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
      this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price
    }
  }

  _changeSellingPlan(event){
    let target = event.target;
    if (!target.closest('recharge-widget')) {
      target = event.target.closest('product-form')?.querySelector('recharge-widget select')
    }
    let id=target.value;
    let dis=target.selectedOptions[0].getAttribute('discount') || 0;
    let product_price = document.querySelector('[data-onetime-price]').innerHTML
    let priceValue = parseFloat(product_price.replace('$', '').replace(',', ''));
    let discountPercentage = parseFloat(dis); // Convert discount to a number

    // Calculate the discounted price
    let discountedPrice = priceValue - (priceValue * discountPercentage / 100);
    target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
    target.closest('[data-purchase_type]').querySelector('[data-subscription_percentage]').innerHTML=`${dis}%`;
    target.closest('[data-purchase_type]').querySelector('[data-subscription_price]').innerHTML=`${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)}`;
    target.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = `${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)}`
    
    // if (type == 'onetime') {
    //   target.closest('.product-details-wrapper').querySelector('[data-currentprice]').innerHTML=`${Utility.formatMoney(variantsData.price, window.globalVariables.money_format)}`;    
    // }else{
    //   target.closest('.product-details-wrapper').querySelector('[data-currentprice]').innerHTML=`${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)}`;
    // }

  }
}
customElements.define('recharge-widget', rechargeWidget);